module.exports = __webpack_public_path__ + "assets/ic-shake.2a09b7c4.svg";